const fromdatanewtb = [
  {
    inputdata: "",
    title: "新经销商",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "selectautocompleteHosType",
    width: "210px",
    btx: true,
    event: "BanewChage",
  },

  {
    inputdata: "",
    title: "经销商编号",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
    disabled: true
  },
  {
    inputdata: "",
    title: "经销商类型 ",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "200px",
    disabled: true
  },
  {
    inputdata: "",
    title: "调入仓库",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请选择",
    types: "",
    inputtype: "select",
    width: "210px",
    btx: true,
    options: [],
  },
];
export default fromdatanewtb;
